function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFireflies = function SvgFireflies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fireflies_svg__a",
    x1: 144.664,
    x2: 54.381,
    y1: -133.778,
    y2: -38.919,
    gradientTransform: "matrix(.8571 0 0 -.8571 -79.239 -68.174)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e82a73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    style: {
      stopColor: "#de2d7a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#c5388f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#9b4ab0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    style: {
      stopColor: "#6262de"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#3b73ff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.4 0H0v18.3h18.4z",
    style: {
      fill: "url(#fireflies_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fireflies_svg__b",
    x1: 145.166,
    x2: 54.883,
    y1: -133.308,
    y2: -38.45,
    gradientTransform: "matrix(.8571 0 0 -.8571 -79.239 -68.174)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff3c82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    style: {
      stopColor: "#f53e88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    style: {
      stopColor: "#dc4598"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    style: {
      stopColor: "#b251b2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#7961d7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#3b73ff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.2 22.1H21.8v18.3h18.4z",
    style: {
      fill: "url(#fireflies_svg__b)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fireflies_svg__c",
    x1: 144.762,
    x2: 114.171,
    y1: -123.201,
    y2: -12.34,
    gradientTransform: "matrix(.8571 0 0 -.8571 -79.239 -68.174)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e82a73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    style: {
      stopColor: "#de2d7a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#c5388f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#9b4ab0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    style: {
      stopColor: "#6262de"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#3b73ff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.2 0H21.8v18.3H56v-2.6c0-4.2-1.7-8.1-4.6-11.1-3-2.9-7-4.6-11.2-4.6",
    style: {
      fill: "url(#fireflies_svg__c)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fireflies_svg__d",
    x1: 134.824,
    x2: 25.31,
    y1: -132.327,
    y2: -98.964,
    gradientTransform: "matrix(.8571 0 0 -.8571 -79.239 -68.174)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e82a73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    style: {
      stopColor: "#de2d7a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#c5388f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#9b4ab0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    style: {
      stopColor: "#6262de"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#3b73ff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 22.1v18.3c0 4.2 1.7 8.1 4.6 11.1 3 2.9 7 4.6 11.2 4.6h2.6v-34z",
    style: {
      fill: "url(#fireflies_svg__d)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fireflies_svg__e",
    x1: 82.208,
    x2: 112.884,
    y1: -52.791,
    y2: -123.081,
    gradientTransform: "matrix(.8571 0 0 -.8571 -79.239 -68.174)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e82a73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.114,
    style: {
      stopColor: "#de286e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    style: {
      stopColor: "#c52361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    style: {
      stopColor: "#9b1a4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    style: {
      stopColor: "#620f30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#3d081e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 18.4 18.3H0z",
    style: {
      opacity: 0.18,
      fill: "url(#fireflies_svg__e)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fireflies_svg__f",
    x1: 107.654,
    x2: 138.33,
    y1: -78.53,
    y2: -148.819,
    gradientTransform: "matrix(.8571 0 0 -.8571 -79.239 -68.174)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e82a73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.114,
    style: {
      stopColor: "#de286e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    style: {
      stopColor: "#c52361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    style: {
      stopColor: "#9b1a4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    style: {
      stopColor: "#620f30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#3d081e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m21.8 22.1 18.4 18.3H21.8z",
    style: {
      opacity: 0.18,
      fill: "url(#fireflies_svg__f)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fireflies_svg__g",
    x1: 70.831,
    x2: 140.305,
    y1: -99.321,
    y2: -145.474,
    gradientTransform: "matrix(.8571 0 0 -.8571 -79.239 -68.174)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e82a73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.114,
    style: {
      stopColor: "#de286e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    style: {
      stopColor: "#c52361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    style: {
      stopColor: "#9b1a4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    style: {
      stopColor: "#620f30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#3d081e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 40.3c0 4.2 1.7 8.1 4.6 11.1 3 2.9 7 4.6 11.2 4.6h2.6V22.1z",
    style: {
      opacity: 0.18,
      fill: "url(#fireflies_svg__g)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fireflies_svg__h",
    x1: 297.69,
    x2: 309.595,
    y1: -1360.885,
    y2: -1454.875,
    gradientTransform: "matrix(.8571 0 0 -.8571 -79.239 -68.174)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e82a73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.114,
    style: {
      stopColor: "#de286e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    style: {
      stopColor: "#c52361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    style: {
      stopColor: "#9b1a4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    style: {
      stopColor: "#620f30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#3d081e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.2 0c4.2 0 8.2 1.7 11.2 4.6S56 11.5 56 15.7v2.6H21.8z",
    style: {
      opacity: 0.18,
      fill: "url(#fireflies_svg__h)"
    }
  }));
};
export default SvgFireflies;